import type { DepositType } from '@api';
import { ActionsCell } from '@common';
import { useTranslation } from 'react-i18next';
import { getDreamhausHrefForDeposit } from './helpers';

type DepositSourceLinkPropsType = {
  deposit: DepositType;
};

export const DepositSourceLink: React.FC<DepositSourceLinkPropsType> = ({
  deposit,
}) => {
  const { t } = useTranslation();
  const href = getDreamhausHrefForDeposit(deposit);

  if (!href) return t('NO_DATA_PLACEHOLDER');

  return (
    <ActionsCell.Root>
      <ActionsCell.Details href={href} />
    </ActionsCell.Root>
  );
};
